import { Routes } from '@angular/router';
import { PageTitleEnum } from '@shared/enums';
import { userGuard } from '@core/guards';

export const orderDetailsRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./order-details-layout/order-details-layout.component').then(
                mod => mod.OrderDetailsLayoutComponent
            ),
        canActivate: [userGuard],
        children: [
            {
                path: '',
                redirectTo: 'results',
                pathMatch: 'full',
            },
            {
                path: 'results',
                loadComponent: () =>
                    import('./_components/order-details-results/order-details-results.component').then(
                        mod => mod.OrderDetailsResultsComponent
                    ),
                title: PageTitleEnum.ORDER_RESULTS,
            },
            // {
            //     path: 'raw-data',
            //     loadComponent: () =>
            //         import('./_components/order-raw-data/order-raw-data.component').then(
            //             mod => mod.OrderRawDataComponent
            //         ),
            //     canActivate: [orderResultsRawDataGuard],
            //     title: PageTitleEnum.ORDER_RAW_DATA,
            // },
            {
                path: 'messages',
                loadComponent: () =>
                    import('./_components/order-details-messages/order-details-messages.component').then(
                        mod => mod.OrderDetailsMessagesComponent
                    ),
                title: PageTitleEnum.ORDER_MESSAGES,
            },
        ],
    },
];

export const orderDetailsSharedRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./order-details-layout/order-details-layout.component').then(
                mod => mod.OrderDetailsLayoutComponent
            ),
        children: [
            {
                path: '',
                redirectTo: 'results',
                pathMatch: 'full',
            },
            {
                path: 'results',
                loadComponent: () =>
                    import('./_components/order-details-results/order-details-results.component').then(
                        mod => mod.OrderDetailsResultsComponent
                    ),
                title: PageTitleEnum.ORDER_RESULTS,
            },
        ],
    },
];
